import React from 'react';
import { useSelector } from 'react-redux';
import Ticker from '../../../components/common/Ticker';
import { toDollar_NoCents } from '../../../helpers/helperFunctions';
import { TickerPower as i18n } from '../../../middlewares/i18n'

const TickerPower = () => {

  const client = useSelector(state => state.client)
  const language = useSelector(state => state.i18n.language.current)

  // remaining comes from the server (remaining_limit at define-transaction,
  // remaining_power on each bill insert); fall back to max - spent for
  // flows that never set it. 0 is a valid value, so only null/undefined
  // triggers the fallback.
  const remaining = (client.remaining === null || client.remaining === undefined)
    ? Math.max(0, client.max - client.spent)
    : client.remaining

  return(
    <Ticker
      title={i18n[language].title}
      content={`$${toDollar_NoCents(remaining)}`}
      left={ true }
    />
  )
}

export default TickerPower;
